// extracted by mini-css-extract-plugin
export default {"head":"History_head__Bjaai","main_hero":"History_main_hero__c30mO","form":"History_form__1Jyn8","navBar":"History_navBar__tfiYh"};